<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/koB8Rr/tc-custom/9781939038937.jpg?1698090300965" alt="This image is the cover for the book Blind Faith, Caitlyn Tierney FBI Thrillers"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Blind Faith, Caitlyn Tierney FBI Thrillers
      </h1>
      <p class="bookDescription body article font2">
        <b>A man executed for murder may have taken the ultimate secret to his grave in the <i>New York Times</i> bestselling author’s thriller series debut.</b><br/><br/>Sarah Durandt knows that the serial killer who murdered her husband and son has paid the ultimate price. But the Damien Wright went to his death refusing to reveal where he’d buried their bodies. Now, Sarah is determined to find them. She’s prepared for the shock of seeing them dead. But what she finds is even more horrifying . . .<br/><br/>Despite Damian’s confession, DNA evidence suggests that he wasn’t the real killer. It’s persuasive enough that FBI Supervisory Special Agent Caitlyn Tierney is reopening the case to hunt down a killer who may still be at large. Now, for Sarah, the nightmare is only beginning . . .
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        CJ Lyons
      </h2>
      
      <p class="authorDescription body article">New York Times and USA Today bestselling author of over forty novels, former pediatric ER doctor CJ Lyons has lived the life she writes about in her cutting-edge Thrillers with Heart.    CJ has been called a “master within the genre" (Pittsburgh Magazine) and her work has been praised as “breathtakingly fast-paced” and “riveting” (Publishers Weekly) with “characters with beating hearts and three dimensions” (Newsday).   Her novels have twice won the International Thriller Writers’ prestigious Thriller Award, the RT Reviewers’ Choice Award, the Readers’ Choice Award, the RT Seal of Excellence, and the Daphne du Maurier Award for Excellence in Mystery and Suspense.   Learn more about CJ’s Thrillers with Heart at www.CJLyons.net</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      EdgyReads
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?64330c0e